import axios from "axios";
import store from "@/store";
import md5 from "js-md5";
import { getToken, setToken } from "@/libs/util";

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl;
    this.queue = {};
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    };
    return config;
  }
  destroy(url) {
    delete this.queue[url];
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        this.queue[url] = true;
        let token = getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      error => {
        console.log(error);
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url);

        const { data, status } = res;
        return { data, status };
      },
      error => {
        this.destroy(url);
        let errorInfo = error.response;
        // console.log(errorInfo.status);

        switch (errorInfo.status) {
          case 401:
            // 返回 401 清除token信息并跳转到登录页面
            window.location.href = "/login";
            break;
          case 422:
            let errorMsg = errorInfo.data.message;
            errorMsg += "<br>";
            for (var key in errorInfo.data.errors) {
              errorMsg += errorInfo.data.errors[key][0] + "<br>";
            }

            return Promise.reject(errorMsg);
            break;
          case 405:
            return Promise.reject(errorInfo.data);
            break;
          case 500:
            return Promise.reject(errorInfo.data.message);
            break;
          default:
            return Promise.reject(errorInfo.data);
        }

        return Promise.reject(error);
      }
    );
  }
  request(options) {
    // alert(window.XMLHttpRequest);
    //开始判断防止重复提交处理
    let csrf = options.csrf;
    if (typeof csrf == "undefined") csrf = true;
    if (options.method == "post" && csrf) {
      let postBufferData = store.state.message.postData;
      let thisBufferData = md5(options.url + JSON.stringify(options.data));
      if (typeof postBufferData !== "undefined" && postBufferData.length > 0) {
        //和本地提交的比较
        if (postBufferData == thisBufferData) {
          return Promise.reject("数据重复提交");
        } else {
          store.commit("setPostData", thisBufferData);
        }
      } else {
        store.commit("setPostData", thisBufferData);
      }
    }
    //防止重复提交结束
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}
export default HttpRequest;
